import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllUserRoles, userCreationApi } from "../server/rolesAllApi";
import { toast } from "react-toastify";

const EditUser = () => {
  const location = useLocation();
  const userToEdit = location.state?.user;

  const [roles, setRoles] = useState([]);
  const [formState, setFormState] = useState({
    f_name: "",
    l_name: "",
    profile_img: "",
    email: "",
    phone: "",
    password: "",
    roleId: "",
    address: "",
    post_code: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    setToken(token);

    const fetchRoles = () => {
      getAllUserRoles()
        .then((response) => {
          if (Array.isArray(response.data.roles)) {
            setRoles(response.data.roles);
          } else {
            throw new Error("Roles data is not an array");
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error("Failed to fetch roles:", err);
          setError("Failed to fetch roles.");
          setLoading(false);
        });
    };

    fetchRoles();
  }, []);

  useEffect(() => {
    if (userToEdit) {
      const role = roles.find((role) => role.rolename === userToEdit.roleName);
      setFormState({
        f_name: userToEdit.f_name,
        l_name: userToEdit.l_name,
        profile_img: userToEdit.profile_img,
        email: userToEdit.email,
        phone: userToEdit.phone,
        password: "",
        roleId: role ? role._id : "",
        address: userToEdit.address,
        post_code: userToEdit.post_code,
      });
    }
  }, [userToEdit, roles]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "profile_img") {
      setFormState({
        ...formState,
        profile_img: e.target.files[0],
      });
    } else {
      setFormState({
        ...formState,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("f_name", formState.f_name);
      formData.append("l_name", formState.l_name);
      formData.append("email", formState.email);
      formData.append("phone", formState.phone);
      formData.append("roleId", formState.roleId);
      formData.append("address", formState.address);
      formData.append("post_code", formState.post_code);

      if (formState.profile_img) {
        formData.append("profile_img", formState.profile_img);
      }

      if (formState.password) {
        formData.append("password", formState.password);
      }

      if (token) {
        const reqHeader = {
          authorization: `Bearer ${token}`,
        };

        if (userToEdit) {
        //   updateUser(userToEdit._id, formData, reqHeader)
        //     .then((response) => {
        //       toast.success("User updated successfully!");
        //       navigate("/users");
        //     })
        //     .catch((error) => {
        //       console.error("Failed to update user:", error);
        //       toast.error("Failed to update user.");
        //     });
        } else {
          userCreationApi(formData, reqHeader)
            .then((response) => {
              toast.success("User created successfully!");
              navigate("/guest-list");
            })
            .catch((error) => {
              console.error("Failed to create user:", error);
              toast.error("Failed to create user.");
            });
        }
      }
    } catch (err) {
      console.error("Error creating or updating user:", err);
      setError("Error creating or updating user.");
      toast.error("Error creating or updating user.");
    }
  };

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-body p-24">
        <div className="row justify-content-center">
          <div className="col-xxl-6 col-xl-8 col-lg-10">
            <div className="card border">
              <div className="card-body">
                <form action="#">
                  {/* First Name */}
                  <div className="mb-20">
                    <label
                      htmlFor="f_name"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      First Name
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      id="f_name"
                      name="f_name"
                      className="form-control radius-8"
                      value={formState.f_name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* Last Name */}
                  <div className="mb-20">
                    <label
                      htmlFor="l_name"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Last Name
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      id="l_name"
                      name="l_name"
                      className="form-control radius-8"
                      value={formState.l_name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* Email */}
                  <div className="mb-20">
                    <label
                      htmlFor="email"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Email
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control radius-8"
                      value={formState.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* Phone */}
                  <div className="mb-20">
                    <label
                      htmlFor="phone"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Phone
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      id="phone"
                      name="phone"
                      className="form-control radius-8"
                      value={formState.phone}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* Address */}
                  <div className="mb-20">
                    <label
                      htmlFor="address"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Address Lane
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      id="address"
                      name="address"
                      className="form-control radius-8"
                      value={formState.address}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* Post Code */}
                  <div className="mb-20">
                    <label
                      htmlFor="post_code"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Post Code
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      id="post_code"
                      name="post_code"
                      className="form-control radius-8"
                      value={formState.post_code}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* Password */}
                  <div className="mb-20">
                    <label
                      htmlFor="password"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Password
                      {userToEdit ? null : (
                        <span className="text-danger-600">*</span>
                      )}
                    </label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      className="form-control radius-8"
                      value={formState.password}
                      onChange={handleInputChange}
                      required={!userToEdit}
                    />
                  </div>

                  {/* Role */}
                  <div className="mb-20">
                    <label
                      htmlFor="roleId"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Role
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                      id="roleId"
                      name="roleId"
                      className="form-control radius-8 form-select"
                      value={formState.roleId}
                      onChange={handleInputChange}
                      required
                    >
                      {roles.map((role) => (
                        <option key={role._id} value={role._id}>
                          {role.rolename}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Profile Image */}
                  <div className="mb-20">
                    <label
                      htmlFor="profile_img"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Profile Image
                    </label>
                    <input
                      type="file"
                      id="profile_img"
                      name="profile_img"
                      className="form-control radius-8"
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                      onClick={() => navigate("/department")}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      onClick={handleSubmit}
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
